export const constantes = {
  APLICACION: process.env.APLICACION,
  MS_AUTENTICACION: process.env.MS_AUTENTICACION,
  MS_AUDITORIA: process.env.MS_AUDITORIA,
  MS_LOGISTICA: process.env.MS_LOGISTICA,
};
